import React from 'react';
import PropTypes from 'prop-types';
import SalesFilterForm from '../formSection/salesFilterForm/salesFilterForm';
import TicketsFilterForm from 'components/tickets/formSection/ticketsFilterForm/ticketsFilterForm';
import SiteFilterForm from 'components/installation/siteFilterForm/siteFilterForm';
import SiteFilterFormForEngg from 'components/installation/siteFilterForm/siteFilterFormForEngg';
import MeetingFilter from 'components/installation/siteFilterForm/meetingFilter';
import FeedbackFilter from 'components/installation/siteFilterForm/feedbackFilter';
import GoLiveFilterForm from 'components/maintenance/goLiveFilterForm/goLiveFilterForm';
import PmSitiesFilterForm from 'components/maintenance/pmSitiesFilterForm/pmSitiesFilterForm';
import ApprovalCampListingFilterForm from 'components/maintenance/ApprovalCampListingFilterForm/approvalCampListingFilterForm';
import InvoiceFilterForm from 'components/maintenance/InvoiceFilterForm/InvoiceFilterForm';
import PmTicketsFilterForm from 'components/maintenance/pmTicketsFilterForm/pmTicketsFilterForm';
import RmTicketsFilterForm from 'components/maintenance/rmTicketsFilterForm/rmTicketsFilterForm';
import CteTicketsFilterForm from 'components/maintenance/cteTicketsFilterForm/cteTicketsFilterForm';
import EmployeeFilterForm from 'components/maintenance/employeeFilterForm/employeeFilterForm';
import CarnivalFilterForm from 'components/brandActivation/carnivalFilterForm/carnivalFilterForm';
import FdFilterForm from 'components/brandActivation/fdFilterForm/fdFilterForm';
import NormalFilterForm from "../../../pages/brandActivation/conductCarnival/NormalOnboarding/NormalFilter";
import NetworkEngineerFilter from "../../maintenance/NetworkEngineerTask";
import ClientFilterForm from "../../maintenance/clientFilterForm"
import SiteStatusFilterForm from "../../maintenance/siteStatusFilterForm"
// NOTE: Avoid react-bootstrap Button here because global `.btn i/img { position:absolute; }`
// interferes with the close icon alignment/click area in the filter sidebar header.
import BaBusinessListFilterForm from "../formSection/BaBussinessList/BusinessList";
import HelpdeskFilter from "../../HelpdeskUsers/HelpDeskFilter";
import UserFilter from "../../HelpdeskUsers/UserFilter";
import QuotationFilter from './QuotationFilter';
import ValetIncentiveFilter from './ValetIncentiveFilter';
import CampaignFilter from '../formSection/CampaignFilter/CampaignFilter';
import SalaryMasterFilter from './SalaryMasterFilter';
import ValetSupportFilterForm from '../formSection/ValetSupportFilterForm/ValetSupportFilterForm';
import AbscondDriverFilterForm from '../formSection/AbscondDriverFilterForm/AbscondDriverFilterForm';
import DCTransferFilter from '../formSection/DCTransfer/DCTransferFilter';
import FinanceMrfFilter from './FinanceMrfFilter';
import AllValetListFilter from './AllValetListFilter';
import EmployeeCreditFilter from './EmployeeCreditFilter';
import RateMeetingFilter from './RateMeetingFilter';
import InstallationDateApproval from './InstallationDateApproval';
import ContractRenewalFilter from './ContractRenewalFilter';
import EventSalaryFilter from './EventSalaryFilter';
import UcdDealerFilter from './UcdDealerFilter';
import CasesFilterUcd from './CasesFilterUcd';
import PerformanceFilter from './performanceFilter';
import RcCasesFilter from "./RcCaseFilter";
import CommissionPayoutFilter from './CommissionPayoutFilter';
import CompetitionMappingFilter from './CompetitionMappingFilter';
import OffroleEmployeesFilter from './OffroleEmployeesFilter';
import MasterAttendanceFilter from './MasterAttendanceFilter';
import BusinessItemFilter from './BusinessItemFilter';
import HsnFilter from './HsnFilter';
import LobFilter from './LobFilter';
import TagOrdersFilter from './TagOrdersFilter';
import SalesTargetsFilter from './SalesTargetsFilter';
import SiteDashboardFilter from './SiteDashboardFilter';
import DynamicContentsFilter from './DynamicContentsFilter';
import SiteLeadReferralFilter from './SiteLeadReferralFilter';
import ClientClientReferralFilter from './ClientClientReferralFilter';
import ServicePrFilter from './ServicePrFilter';
import ServicePrApprovalsFilter from './ServicePrApprovalsFilter';
import VendorListingFilter from './VendorListingFilter';
import InspectionRequestsFilter from './InspectionRequestsFilter';
import DarwinRecordFilter from './DarwinRecordFilter';
import DarwinRegularizationFilter from './DarwinRegularizationFilter';


const ListFilters = ({
  showFilter = false,
  filterToggle,
  applyFilter,
  getZones,
  filterPreSalesListing = false,
  filterFinanceSalesListing = false,
  filterApprovalCampListing = false,
  filterTicketsListing = false,
  liveFilterDropDown = false,
  pmdropdownList = false,
  pmdashBoardList = false,
  pmTicketFilter = false,
  siteFilters = false,
  meetingFilter = false,
  feedBackFilter=false,
  rmTicketFilter = false,
  cteTicketFilter = false,
  rmSoftwareTicketFilter = false,
  rmHardwareTicketFilter = false,
  complaintFilter = false,
  defaultInternalStatusId = '',
  hideL2ClientFilters = false,
  employeeFilterList = false,
  pmApprovalList = false,
  listFilterData = null,
  invoiceFilters = false,
  carnivalFilters = false,
  normalOnboardingFilters = false,
  networkEngFilter = false,
  fdFilters = false,
  zones = [],
  status = [],
  statusId,
  isRoleId,
  projectOnboardingStatus = false,
  siteApprovalFinance = false,
  filterClientList = false,
  clientFilter = false,
  siteFiltersForEngg = false,
  BaBusinessListFilter=false,
  CampaignListFilter=false,
  ValetSupportFilter=false,
  AbscondDriverFilter=false,
  helpdeskFilter=false,
  localstorageKey='',
  helpdeskUserFilter=false,
  salaryMasterFilter=false,
  quotationFilter=false,
  valetIncentiveFilter=false,
  dcTransferFilter=false,
  financeMrfFilter = false,
  allValetListFilter = false,
  employeeCreditFilter = false,
  meetingRatingsFilter = false,
  installationDateApproval=false,
  emailDropdownFilter,
  contractRenewalFilter=false,
  type,
  userFilter,
  eventSalaryFilter=false,
  ucdFilter=false,
  ucdCasesFilter = false,
  performanceFilter=false,
  rcCasesFilter = false,
  commissionPayoutFilter = false,
  competitionMappingFilter = false,
  cityDropdown,
  createdByDropdown,
  offroleEmployeeFilter =false,
  getDropdownDatas,
  activeInactive,
  masterAttendanceFilter,
  businessItemFilter,
  hsnFilter,
  setSelectedName=false,
  setSelectedCode=false,
  item_type=false,
  setSelectedHsn=false,
  setSelectedGst=false,
  setSelectedUser=false,
  lobFilter,
  setSelectedLobCode=false,
  setSelectedFilterLob=false,
  setSelectedDimension=false,
  tagOrdersFilter,
  setSelectedFullfillStatus=false,
  setSelectedDateFrom=false,
  setSelectedDateTo=false,
  salesTargetsFilter = false,
  siteDashboardFilter = false,
  dynamicContentsFilter = false,
  siteLeadReferralFilter = false,
  clientClientReferralFilter = false,
  servicePrFilters = false,
  servicePrApprovalsFilters = false,
  vendorListingFilter = false,
  inspectionRequestsFilter = false,
  darwinRecordFilter = false,
  darwinRegularizationFilter = false,
  darwinRecordFilterProps = {},
  darwinRegularizationFilterProps = {},
}) => {

  return (
    <div className={showFilter ? 'show-filter' : ''}>
      {showFilter && (
        <div className="filter-wrapper">
          <div className="filter-heading">
            <h4>Filters</h4>
            <button type="button" onClick={filterToggle} className="close" aria-label="Close filters" />
          </div>
          <div className="filter-body scrollbar-styling">
            {servicePrFilters && (
              <ServicePrFilter
                applyFilter={(val) => applyFilter(val)}
                listFilterData={listFilterData}
              />
            )}
            {servicePrApprovalsFilters && (
              <ServicePrApprovalsFilter applyFilter={(val) => applyFilter(val)} />
            )}
            {vendorListingFilter && (
              <VendorListingFilter
                applyFilter={(val) => applyFilter(val)}
                listFilterData={listFilterData}
              />
            )}
            {inspectionRequestsFilter && (
              <InspectionRequestsFilter
                applyFilter={(val) => applyFilter(val)}
                listFilterData={listFilterData}
              />
            )}
            {salesTargetsFilter && (
              <SalesTargetsFilter
                applyFilter={(val) => applyFilter(val)}
                listFilterData={listFilterData}
              />
            )}
            {siteDashboardFilter && (
              <SiteDashboardFilter
                applyFilter={(val) => applyFilter(val)}
                listFilterData={listFilterData}
                appliedFilterValues={listFilterData?.appliedFilterValues}
              />
            )}
            {dynamicContentsFilter && (
              <DynamicContentsFilter
                applyFilter={(val) => applyFilter(val)}
                listFilterData={listFilterData}
              />
            )}
            {siteLeadReferralFilter && (
              <SiteLeadReferralFilter
                applyFilter={(val) => applyFilter(val)}
                listFilterData={listFilterData}
              />
            )}
            {clientClientReferralFilter && (
              <ClientClientReferralFilter
                applyFilter={(val) => applyFilter(val)}
                listFilterData={listFilterData}
              />
            )}
            {performanceFilter && (
                <PerformanceFilter
                    applyFilter={(val) => applyFilter(val)}
                    listFilterData={listFilterData}
                />
            )}
            {helpdeskFilter && (
                <HelpdeskFilter
                    applyFilter={(val) => applyFilter(val)}
                    listFilterData={listFilterData}
                    localstorageKey={localstorageKey}
                />
            )}
            {helpdeskUserFilter && (
                <UserFilter
                    applyFilter={(val) => applyFilter(val)}
                    localstorageKey={localstorageKey}
                />
            )}
            {quotationFilter && (
                <QuotationFilter
                    applyFilter={(val) => applyFilter(val)}
                    
                />
            )}
            {BaBusinessListFilter && (
                <BaBusinessListFilterForm
                    applyFilter={(val) => applyFilter(val)}
                    getZones={(val) => getZones(val)}
                    reportees={
                      listFilterData !== null ? listFilterData.reportees : []
                    }
                    cities={listFilterData !== null ? listFilterData.cities : []}
                    zones={zones}
                    isRoleId={isRoleId}
                />
            )}
            {CampaignListFilter && (
                <CampaignFilter
                    applyFilter={(val) => applyFilter(val)}
                />
            )}
            {ValetSupportFilter && (
                <ValetSupportFilterForm
                    applyFilter={(val) => applyFilter(val)}
                />
            )}
            {AbscondDriverFilter && (
                <AbscondDriverFilterForm
                    applyFilter={(val) => applyFilter(val)}
                />
            )}
            {(dcTransferFilter &&
                <DCTransferFilter
                   applyFilter={(val) => applyFilter(val)}
                />
            )}
            {filterPreSalesListing && (
              <SalesFilterForm
                applyFilter={(val) => applyFilter(val)}
                getZones={(val) => getZones(val)}
                status={listFilterData !== null ? listFilterData.status : []}
                reportees={
                  listFilterData !== null ? listFilterData.reportees : []
                }
                cities={listFilterData !== null ? listFilterData.cities : []}
                lead_category={listFilterData !== null ? listFilterData.lead_category : []}
                zones={zones}
                statusId={statusId}
                isRoleId={isRoleId}
                projectOnboardingStatus={projectOnboardingStatus}
              />
            )}
            {siteApprovalFinance && (
              <SiteStatusFilterForm
                applyFilter={(val) => applyFilter(val)}
              />
            )}
            {filterFinanceSalesListing && (
              <SalesFilterForm
                applyFilter={(val) => applyFilter(val)}
                getZones={(val) => getZones(val)}
                status={listFilterData !== null ? listFilterData.status : []}
                reportees={
                  listFilterData !== null ? listFilterData.reportees : []
                }
                cities={listFilterData !== null ? listFilterData.cities : []}
                lead_category={listFilterData !== null ? listFilterData.lead_category : []}
                zones={zones}
                statusId={statusId}
                isRoleId={isRoleId}
                projectOnboardingStatus={projectOnboardingStatus}
              />
            )}
            {filterApprovalCampListing && (
              <ApprovalCampListingFilterForm
                applyFilter={(val) => applyFilter(val)}
                status={status}
              />
            )}
            {filterTicketsListing && (
              <TicketsFilterForm
                applyFilter={(val) => applyFilter(val)}
                status={status}
              />
            )}
            {invoiceFilters && (
              <InvoiceFilterForm
                applyFilter={(val) => applyFilter(val)}
                status={status}
                invoiceFilters={invoiceFilters}
              />
            )}

            {carnivalFilters && (
              <CarnivalFilterForm
                applyFilter={(val) => applyFilter(val)}
              />
            )}

            {normalOnboardingFilters && (
                <NormalFilterForm
                    applyFilter={(val) => applyFilter(val)}
                />
            )}

            {fdFilters && (
              <FdFilterForm
                applyFilter={(val) => applyFilter(val)}
              />
            )}

            {siteFilters && (
              <SiteFilterForm
                applyFilter={(val) => applyFilter(val)}
                siteTypes={
                  listFilterData !== null ? listFilterData.site_types : []
                }
                assignedAreas={
                  listFilterData !== null ? listFilterData.assigned_areas : []
                }
                reportees={
                  listFilterData !== null ? listFilterData.reportees : []
                }
                child={
                  listFilterData !== null ? listFilterData.child : []
                }
                siteStatus={
                  listFilterData !== null ? listFilterData.site_status : []
                }
                city={
                  listFilterData !== null ? listFilterData.city : []
                }
                showCommercialFilter={true}
              />
            )}
            {siteFiltersForEngg && (
              <SiteFilterFormForEngg
                applyFilter={(val) => applyFilter(val)}
                siteTypes={
                  listFilterData !== null ? listFilterData.site_types : []
                }
                assignedAreas={
                  listFilterData !== null ? listFilterData.assigned_areas : []
                }
                reportees={
                  listFilterData !== null ? listFilterData.reportees : []
                }
                child={
                  listFilterData !== null ? listFilterData.child : []
                }
                siteStatus={
                  listFilterData !== null ? listFilterData.site_status : []
                }
                city={
                  listFilterData !== null ? listFilterData.city : []
                }
                showCommercialFilter={true}
              />
            )}
            {meetingFilter && (
              <MeetingFilter
                applyFilter={(val) => applyFilter(val)}
                siteTypes={
                  listFilterData !== null ? listFilterData.site_types : []
                }
                assignedAreas={
                  listFilterData !== null ? listFilterData.assigned_areas : []
                }
                reportees={
                  listFilterData !== null ? listFilterData.reportees : []
                }
                siteStatus={
                  listFilterData !== null ? listFilterData.site_status : []
                }
                agenda={
                  listFilterData !== null ? listFilterData.agenda : []
                }
              />
            )}
            {feedBackFilter && (
              <FeedbackFilter
                applyFilter={(val) => applyFilter(val)}
                
              />
            )}

            {liveFilterDropDown && (
              <GoLiveFilterForm
                applyFilter={(val) => applyFilter(val)}
                siteTypes={
                  listFilterData !== null ? listFilterData.site_type : []
                }
                reportees={
                  listFilterData !== null ? listFilterData.reportees : []
                }
              />
            )}

            {(pmdropdownList || pmApprovalList) && (
              <PmSitiesFilterForm
                applyFilter={(val) => applyFilter(val)}
                siteTypes={
                  listFilterData !== null ? listFilterData.site_type : []
                }
                statusTypes={
                  listFilterData !== null ? listFilterData.status : []
                }
                reportees={
                  listFilterData !== null ? listFilterData.reportees : []
                }
                statusId={pmApprovalList ? [4,5,7] : 0}
                pmApprovalList = {pmApprovalList ? pmApprovalList: false}
                dashboard = {false}
                isRoleId={isRoleId}
                city={
                  listFilterData !== null ? listFilterData.city : []
                }
              />
            )}
             {(pmdashBoardList) && (
              <PmSitiesFilterForm
                applyFilter={(val) => applyFilter(val)}
                siteTypes={
                  listFilterData !== null ? listFilterData.site_type : []
                }
                reportees={
                  listFilterData !== null ? listFilterData.reportees : []
                }
                statusId={pmApprovalList ? [4,5,7] : 0}
                dashboard = {true}
                isRoleId={isRoleId}
              />
            )}

            {pmTicketFilter && (
              <PmTicketsFilterForm
                applyFilter={(val) => applyFilter(val)}
                siteTypes={listFilterData !== null ? listFilterData.status : []}
                reportees={
                  listFilterData !== null ? listFilterData.reportees : []
                }
                isRoleId={isRoleId}
                statusId={statusId}
                city={
                  listFilterData !== null ? listFilterData.city : []
                }
              />
            )}

            {rmTicketFilter && (
              <RmTicketsFilterForm
                applyFilter={(val) => applyFilter(val)}
                siteTypes={listFilterData !== null ? listFilterData.status : []}
                siteCompStatus={listFilterData !== null ? listFilterData.complaint_status : []}
                internalStatus={listFilterData !== null ? listFilterData.internal_status : []}
                reportees={
                  listFilterData !== null ? listFilterData.reportees : []
                }
                statusId={statusId}
                complaintFilter = {complaintFilter}
                defaultInternalStatusId={defaultInternalStatusId}
                hideL2ClientFilters={hideL2ClientFilters}
                city={
                  listFilterData !== null ? listFilterData.city : []
                }
                ticket_tags={listFilterData!==null ? listFilterData.ticket_tags : []}
                cx_category={listFilterData!==null ? listFilterData.cx_category : ""}
                localstorageKey={localstorageKey || "applyFilter"}
              />
            )}

            {cteTicketFilter && (
              <CteTicketsFilterForm
                applyFilter={(val) => applyFilter(val)}
                internalStatus={listFilterData !== null ? listFilterData.internal_status : []}
                reportees={
                  listFilterData !== null ? listFilterData.reportees : []
                }
                localstorageKey={localstorageKey || "cteComplaintList"}
              />
            )}

            {rmSoftwareTicketFilter && (
              <RmTicketsFilterForm
                applyFilter={(val) => applyFilter(val)}
                siteTypes={listFilterData !== null ? listFilterData.status : []}
                siteCompStatus={listFilterData !== null ? listFilterData.complaint_status : []}
                internalStatus={listFilterData !== null ? listFilterData.internal_status : []}
                reportees={
                  listFilterData !== null ? listFilterData.reportees : []
                }
                statusId={statusId}
                complaintFilter = {complaintFilter}
                defaultInternalStatusId={defaultInternalStatusId}
                hideL2ClientFilters={hideL2ClientFilters}
                city={
                  listFilterData !== null ? listFilterData.city : []
                }
                ticket_tags={listFilterData!==null ? listFilterData.ticket_tags : []}
                cx_category={listFilterData!==null ? listFilterData.cx_category : ""}
                localstorageKey={localstorageKey || "applyFilter"}
              />
            )}

            {rmHardwareTicketFilter && (
              <RmTicketsFilterForm
                applyFilter={(val) => applyFilter(val)}
                siteTypes={listFilterData !== null ? listFilterData.status : []}
                siteCompStatus={listFilterData !== null ? listFilterData.complaint_status : []}
                internalStatus={listFilterData !== null ? listFilterData.internal_status : []}
                reportees={
                  listFilterData !== null ? listFilterData.reportees : []
                }
                statusId={statusId}
                complaintFilter = {complaintFilter}
                defaultInternalStatusId={defaultInternalStatusId}
                hideL2ClientFilters={hideL2ClientFilters}
                city={
                  listFilterData !== null ? listFilterData.city : []
                }
                ticket_tags={listFilterData!==null ? listFilterData.ticket_tags : []}
                cx_category={listFilterData!==null ? listFilterData.cx_category : ""}
                localstorageKey={localstorageKey || "applyFilter"}
              />
            )}

            {employeeFilterList && (
              <EmployeeFilterForm
                applyFilter={(val) => applyFilter(val)}
                siteTypes={listFilterData !== null ? listFilterData.status : []}
                reportees={
                  listFilterData !== null ? listFilterData.reportees : []
                }
                statusId={statusId}
              />
            )}

            {networkEngFilter &&
               <NetworkEngineerFilter
                   applyFilter={(val) => applyFilter(val)}
                   roleId={isRoleId}
               />
            }
            {meetingRatingsFilter &&
              <RateMeetingFilter
               applyFilter={(val) => applyFilter(val)}
               emailDropdownFilter={emailDropdownFilter}
               type={type}
               userFilter={userFilter}
              />
            }
            {filterClientList &&
              <ClientFilterForm
                   applyFilter={(val) => applyFilter(val)}
                   roleId={isRoleId}
               />
            }
           {valetIncentiveFilter && (
              <ValetIncentiveFilter
                applyFilter={(val) => applyFilter(val)}
              />
            )}
            {allValetListFilter && (
              <AllValetListFilter
                applyFilter={(val) => applyFilter(val)}
              />
            )}
            {employeeCreditFilter && (
              <EmployeeCreditFilter
                applyFilter={(val) => applyFilter(val)}
              />
            )}
            {salaryMasterFilter && (
              <SalaryMasterFilter
                applyFilter={(val) => applyFilter(val)}
              />
            )}
            {financeMrfFilter && (
              <FinanceMrfFilter
                applyFilter={(val) => applyFilter(val)}
                listFilterData={listFilterData}
              />
            )}
            {installationDateApproval && (
              <InstallationDateApproval
                applyFilter={(val) => applyFilter(val)}
                listFilterData={listFilterData}
              />
            )}
            {contractRenewalFilter && (
              <ContractRenewalFilter
                applyFilter={(val) => applyFilter(val)}
                contractStatus={
                  listFilterData !== null ? listFilterData.contract_status : []
                }
                renewalStatus={
                  listFilterData !== null ? listFilterData.renewal_status : []
                }
                contractTypes={
                  listFilterData !== null ? listFilterData.contract_type : []
                }
                cities={
                  listFilterData !== null ? listFilterData.city : []
                }
                buckets={
                  listFilterData !== null ? listFilterData.buckets : []
                }
              />
            )}
            {eventSalaryFilter && (
              <EventSalaryFilter
                showFilter={true}
                applyFilter={(val) => applyFilter(val)}
                listFilterData={listFilterData}
                localstorageKey={localstorageKey}
              />
            )}
            {ucdFilter && (
              <UcdDealerFilter
                showFilter={true}
                applyFilter={(val) => applyFilter(val)}
                listFilterData={listFilterData}
                localstorageKey={localstorageKey}
              />
            )}
            {ucdCasesFilter && (
              <CasesFilterUcd
                showFilter={true}
                applyFilter={(val) => applyFilter(val)}
                listFilterData={listFilterData}
                localstorageKey={localstorageKey}
              />
            )}
            {rcCasesFilter &&
                <RcCasesFilter
                    rcFilter={listFilterData}
                    localstorageKey={localstorageKey}
                    applyFilter={(val) => applyFilter(val)}
                />
            }
            {commissionPayoutFilter && (
              <CommissionPayoutFilter
                applyFilter={(val) => applyFilter(val)}
              />
              
            )}
            
            {competitionMappingFilter && (
              <CompetitionMappingFilter
                applyFilter={(val) => applyFilter(val)}
                createdByDropdown={createdByDropdown}
                cityDropdown={cityDropdown}
              />
            )}
            { offroleEmployeeFilter && (
              <OffroleEmployeesFilter
                applyFilter={(val) => applyFilter(val)}
                getDropdownDatas={getDropdownDatas}
                activeInactive={activeInactive}
              />
            )}
            { masterAttendanceFilter && (
              <MasterAttendanceFilter
                applyFilter={(val) => applyFilter(val)}
                getDropdownDatas={getDropdownDatas}
                activeInactive={activeInactive}
                setSelectedUser={setSelectedUser}
                // userList={userList}
              />
            )}
            { businessItemFilter && (
              <BusinessItemFilter
                showFilter={true}
                applyFilter={(val) => applyFilter(val)}
                businessItemFilter
                setSelectedName={setSelectedName}
                setSelectedCode={setSelectedCode}
                type={item_type}
              />
            )}
            { hsnFilter && (
              <HsnFilter
                showFilter={true}
                applyFilter={(val) => applyFilter(val)}
                hsnFilter
                setSelectedHsn={setSelectedHsn}
                setSelectedGst={setSelectedGst}
                />
            )}
            { lobFilter && (
              <LobFilter
                applyFilter={(val) => applyFilter(val)}
                setSelectedFilterLob={setSelectedFilterLob}
                setSelectedLobCode={setSelectedLobCode}
                setSelectedDimension={setSelectedDimension}
              />
            )}
            { tagOrdersFilter && (
              <TagOrdersFilter
                applyFilter={(val) => applyFilter(val)}
                setSelectedFullfillStatus={setSelectedFullfillStatus}
                setSelectedDateFrom={setSelectedDateFrom}
                setSelectedDateTo={setSelectedDateTo}
                listFilterData={listFilterData}
              />
            )}
            {darwinRecordFilter && (
              <DarwinRecordFilter
                {...darwinRecordFilterProps}
                onApply={(val) => applyFilter(val)}
              />
            )}
            {darwinRegularizationFilter && (
              <DarwinRegularizationFilter
                {...darwinRegularizationFilterProps}
                onApply={(val) => applyFilter(val)}
              />
            )}

          </div>
        </div>
      )}
    </div>
  );
};

ListFilters.propTypes = {
  showFilter: PropTypes.bool,
  filterToggle: PropTypes.func,
  applyFilter: PropTypes.func,
  getZones: PropTypes.func,
  getAreas: PropTypes.func,
  
};

export default ListFilters;
